// @ts-strict-ignore
export const scrollToTabSection = (tabId: string, tabItemId: string, offset: number = -160): void => {
	const tabsElement = document.getElementById(tabId)
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const tabButtonElement = tabsElement.querySelector<HTMLElement>(`[id$="${tabItemId}"]`)

	if (tabButtonElement) {
		tabButtonElement.click()
		setTimeout(() => {
			const y = tabButtonElement.getBoundingClientRect().top + window.scrollY + offset
			window.scrollTo({ top: y, behavior: 'smooth' })
		}, 0)
	}
}
